<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Production Records</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" :to="`/production/new-production`">
              <v-icon left>mdi-plus</v-icon>New Production
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
           
            <v-data-table :items-per-page="pageItems" :headers="headers" :items="records" :search="search"
              :mobile-breakpoint="zeroValue">

              <template v-slot:item.ProducedGoodsValue="{ item }">
                <span>{{ item.ProducedGoodsValue | currency  }}</span>
              </template>

               <template v-slot:item.TotalProductionCost="{ item }">
                <span>{{item.TotalProductionCost | currency  }}</span>
              </template>
           
              <template v-slot:item.margin="{ item }">
                <span>{{ (item.ProducedGoodsValue - item.TotalProductionCost) | currency  }}</span>
              </template>

               <template v-slot:item.title="{ item }">
                <span v-if="item.title == ''">
                  {{ item.product.Name }}
                </span>

                 <span v-if="item.title != ''">
                  {{ item.title }}
                </span>
              </template>
   
              <template v-slot:item.date="{ item }">
                {{ item.date | date }}
              </template>
         
            </v-data-table>
           
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    customersDialog: false,
    loader: false,
    zeroValue: 0,
    pageItems: 100,
    date: null,
    headers: [
      { text: "Produced Product", value: "title" },
      { text: "Total Production Cost", value: "TotalProductionCost" },
      { text: "Produced Goods Value", value: "ProducedGoodsValue" },
      { text: "Margin", value: "margin" },
      { text: "Date", value: "date" },
      // { text: "Allowed Variance Qty", value: "allowedVariance" },
      // { text: "Actual Variance Qty", value: "actualVariance" },
      // { text: "Variance Difference", value: "varianceDifference" },
    ],
    records: [],
    excelFile: null
  }),
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    getRecords() {
      const self = this;
      this.$store
        .dispatch("get", `/get-production-records`)
        .then(res => {
          console.log(res, " production res");
          if (res.ResultCode == 1200) {
            self.records = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getRecords();
  }
};
</script>